import ProductModal from './ProductModal';

export default ProductModal;


// WEBPACK FOOTER //
// ./src/components/ProductModal/index.jsx